"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var fdatetime_1 = require("./fdatetime");
/**
 * formatuje datę do formatu yyyy-MM-dd
 * @param dt data typu Date
 */
function fdate(dt) {
    return fdatetime_1.formatDateFunction['yyyy-MM-dd'](dt);
    // return dt.getFullYear() + '-' + padNumber(dt.getMonth() + 1) + '-' + padNumber(dt.getDate());
}
exports.default = fdate;
//# sourceMappingURL=fdate.js.map